import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
    OwnedContactDto,
    OwnedContactsOptionSettingsRequestDto,
    OwnedContactsOptionSettingsResponseDto,
    OwnedContactsOwnerFieldsDto,
    OwnedContactsStatusDto,
    OwnedContactsVendorType,
} from '../../dto';

@Injectable({
    providedIn: 'root',
})
export class OwnedContactsApiService {
    constructor(private readonly baseApiService: BaseApiService) {
    }

    getOwnedContactsOptionSettings(accountId: number): Observable<OwnedContactsOptionSettingsResponseDto> {
        return this.baseApiService.get<OwnedContactsOptionSettingsResponseDto>(`service/contactcloud/ownedcontacts/settings/${accountId}`, { showError: true });
    }

    getOwnedContactsOptionSettingsV2(accountId: number): Observable<OwnedContactsOptionSettingsResponseDto[]> {
        return this.baseApiService.get<OwnedContactsOptionSettingsResponseDto[]>(`service/contactcloud/ownedcontacts/2/settings/${accountId}`, { showError: true });
    }

    saveOwnedContactsOptionSettings(settings: OwnedContactsOptionSettingsRequestDto): Observable<OwnedContactsOptionSettingsResponseDto> {
        return this.baseApiService.post<OwnedContactsOptionSettingsResponseDto>(`service/contactcloud/ownedcontacts/settings`, settings, {
            showError: true,
            showSuccess: true,
        });
    }

    getOwnedContactsStatus(accountId: number): Observable<OwnedContactsStatusDto> {
        return this.baseApiService.get(`service/contactcloud/ownedcontacts/status/${accountId}`, { showError: true });
    }

    getOwnedContactsStatusV2(accountId: number): Observable<OwnedContactsStatusDto[]> {
        return this.baseApiService.get(`service/contactcloud/ownedcontacts/2/status/${accountId}`, { showError: true });
    }

    getOwnedContacts(accountId: number, type?: 'account' | 'contact', vendor?: OwnedContactsVendorType): Observable<OwnedContactDto[]> {
        return this.baseApiService.get(`service/contactcloud/ownedcontacts/owners/${accountId}`, { params: { type, vendor }, showError: true });
    }

    getOwnedContactsByIds(accountId: number, data: string[]): Observable<OwnedContactDto[]> {
        return this.baseApiService.post(`service/contactcloud/ownedcontacts/owners/${accountId}`, data, {showError: true });
    }

    getOwnerFields(accountId: number, vendor: OwnedContactsVendorType): Observable<OwnedContactsOwnerFieldsDto> {
        return this.baseApiService.get(`service/contactcloud/ownedcontacts/owner/fields/${accountId}`, { params: { vendor }, showError: true });
    }
}
